<template>
  <div>
    <v-row
      no-gutters
      class="py-1 px-2"
      style="background-color: #3a1e87; color: white; cursor: pointer"
      @click="toHome"
    >
      <v-col cols="auto">
        <v-img
          height="24px"
          :src="require('@/assets/images/png/icon.png')"
          contain
        />
      </v-col>
      <h4>Riskma 宝達志水</h4>
    </v-row>
    <div class="pa-4">
      <h2>ユーザ管理</h2>
      <p class="subtitle-2 ">ユーザの追加、削除、情報変更するページです。</p>
      <div v-if="mode === 'list'">
        <v-row no-gutters align="end" class="mb-1" style="min-height: 30px">
          <h5>User list</h5>
          <v-spacer></v-spacer>
          <v-btn
            small
            tile
            depressed
            outlined
            class="font-weight-bold mr-1"
            :disabled="selectedUsers.length === 0"
            @click="deleteUser"
          >
            delete
          </v-btn>
          <v-btn
            small
            tile
            depressed
            outlined
            class="font-weight-bold mr-1"
            :disabled="selectedUsers.length === 0"
            @click="changeMode('update')"
          >
            update
          </v-btn>
          <v-btn
            small
            tile
            depressed
            color="warning"
            class="font-weight-bold"
            @click="changeMode('create')"
          >
            create
          </v-btn>
        </v-row>
        <v-card outlined>
          <v-data-table
            dense
            v-model="selectedUsers"
            :headers="headers"
            :items="users"
            :single-select="true"
            show-select
            :loading="isLoading"
            loading-text="Loading... Please wait"
          >
          </v-data-table>
        </v-card>
      </div>
      <div v-else-if="mode === 'create' || mode === 'update'">
        <v-row
          no-gutters
          align="end"
          class="mb-1 mx-auto"
          style="width: 500px; min-height: 30px"
        >
          <h5>{{ mode }} user</h5>
        </v-row>
        <v-card outlined class="pa-4 mx-auto" width="500px">
          <form>
            <v-text-field
              v-model="id"
              :disabled="mode === 'update'"
              :error-messages="idErrors"
              label="ID"
              required
              @input="$v.id.$touch()"
              @blur="$v.id.$touch()"
            ></v-text-field>
            <v-text-field
              v-if="mode === 'create'"
              v-model="password"
              type="password"
              :error-messages="passwordErrors"
              label="パスワード"
              required
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="department"
              :error-messages="departmentErrors"
              label="部署"
              required
              @input="$v.department.$touch()"
              @blur="$v.department.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="userName"
              :error-messages="userNameErrors"
              label="名前"
              required
              @input="$v.userName.$touch()"
              @blur="$v.userName.$touch()"
            ></v-text-field>

            <v-row no-gutters justify="end">
              <template v-if="mode === 'create'">
                <v-btn
                  :disabled="isError"
                  tile
                  small
                  depressed
                  class="mr-4"
                  color="primary"
                  @click="onClickCreate"
                >
                  create
                </v-btn>
              </template>
              <template v-else-if="mode === 'update'">
                <v-btn
                  :disabled="isError"
                  tile
                  small
                  depressed
                  class="mr-4"
                  color="primary"
                  @click="onClickUpdate"
                >
                  update
                </v-btn>
              </template>

              <v-btn tile small depressed @click="cancel">
                cancel
              </v-btn>
            </v-row>
          </form>
        </v-card>
      </div>
      <div class="message-area">
        <v-alert
          v-if="messageType"
          class="mt-2"
          title="system message"
          :type="messageType"
        >
          {{ message }}
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import * as axiosHelper from "../utils/axiosHelper";
import moment from "moment";

const API_URL =
  "https://jxkf9fek8f.execute-api.ap-northeast-1.amazonaws.com/prod";
const DATE_FORMAT = "YYYY/MM/DD HH:mm";

export default {
  mixins: [validationMixin],
  validations: {
    id: { required, minLength: minLength(6) },
    password: { required, minLength: minLength(6) },
    department: { required },
    userName: { required }
  },
  name: "UserDashboard",
  data() {
    return {
      mode: "list",
      headers: [
        { text: "", value: "check" },
        { text: "ID", value: "id" },
        { text: "部署", value: "department" },
        { text: "名前", value: "userName" },
        { text: "登録日時", value: "userCreateDate" }
      ],
      users: [],
      id: "",
      password: "",
      department: "",
      userName: "",
      messageType: null,
      message: "",
      selectedUsers: [],
      isLoading: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    idErrors() {
      const errors = [];
      if (!this.$v.id.$dirty) return errors;
      !this.$v.id.minLength && errors.push("IDは６文字以上で入力してください");
      !this.$v.id.required && errors.push("idを入力してください");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("パスワードは６文字以上で入力してください");
      !this.$v.password.required && errors.push("パスワードを入力してください");
      return errors;
    },
    departmentErrors() {
      const errors = [];
      if (!this.$v.department.$dirty) return errors;
      !this.$v.department.required && errors.push("部署を入力してください");
      return errors;
    },
    userNameErrors() {
      const errors = [];
      if (!this.$v.userName.$dirty) return errors;
      !this.$v.userName.required && errors.push("名前を入力してください");
      return errors;
    },
    isError() {
      if (this.idErrors.length !== 0) {
        return true;
      }
      if (this.departmentErrors.length !== 0) {
        return true;
      }
      if (this.userNameErrors.length !== 0) {
        return true;
      }
      if (this.mode === "create") {
        if (this.passwordErrors.length !== 0) {
          return true;
        }
      }

      return false;
    }
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      this.isLoading = true;
      const url = `${API_URL}/api/users`;
      const response = await axiosHelper.getOutsideApi(url);
      if (response && response.length > 0) {
        const users = [];
        response.forEach(user => {
          users.push({
            id: user.id,
            department: user.department,
            userName: user.userName,
            userCreateDate: moment
              .utc(user.userCreateDate, DATE_FORMAT)
              .local()
              .format(DATE_FORMAT)
          });
        });

        this.users = users;
      }
      this.isLoading = false;
    },
    async signup() {
      const url = `${API_URL}/api/users`;
      const response = await axiosHelper.postOutsideApi(url, {
        id: this.id,
        password: this.password,
        department: this.department,
        userName: this.userName
      });
      if (response === null) {
        this.showMessage("error", "登録に失敗しました。");
      } else if (response === "ok") {
        this.showMessage("success", "登録に成功しました。");
        this.cancel();
      }
    },
    async deleteUser() {
      const url = `${API_URL}/api/users`;
      const response = await axiosHelper.deleteOutsideApi(url, {
        id: this.selectedUsers[0].id
      });
      if (response === null) {
        this.showMessage("error", "削除に失敗しました。");
      } else if (response === "ok") {
        this.showMessage("success", "削除に成功しました。");
        this.cancel();
      }
    },
    async updateUser() {
      const url = `${API_URL}/api/users`;
      const response = await axiosHelper.putOutsideApi(url, {
        id: this.id,
        department: this.department,
        userName: this.userName
      });
      if (response === null) {
        this.showMessage("error", "変更に失敗しました。");
      } else if (response === "ok") {
        this.showMessage("success", "変更に成功しました。");
        this.cancel();
      }
    },
    onClickCreate() {
      this.$v.$touch();
      if (!this.isError) {
        this.signup();
      }
    },
    onClickUpdate() {
      this.$v.$touch();
      if (!this.isError) {
        this.updateUser();
      }
    },
    cancel() {
      this.$v.$reset();
      this.id = "";
      this.password = "";
      this.department = "";
      this.userName = "";

      this.fetchUsers();
      this.changeMode("list");
    },
    showMessage(type, string) {
      this.messageType = type;
      this.message = string;
      setTimeout(() => {
        this.messageType = null;
        this.message = "";
      }, 3000);
    },
    toHome() {
      this.$router.push("/");
    },
    changeMode(mode) {
      if (mode === "update") {
        const user = this.selectedUsers[0];
        this.id = user.id;
        this.department = user.department;
        this.userName = user.userName;
      }

      this.mode = mode;
    }
  }
};
</script>
<style>
h5 {
  margin-bottom: 0;
  line-height: 1;
}
</style>
